import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export default function HrPortalAccessModal({ result, onClose }) {
  const [copied, setCopied] = useState('');

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  if (!result) return null;

  const portal = result.portal_user || {};
  const employee = result.employee || {};
  const status = result.status || 'created';

  const statusNote =
    status === 'created'
      ? 'New portal user created. Copy the password now — it may not be shown again.'
      : status === 'updated'
        ? 'Existing portal user was updated with attendance access.'
        : 'This employee already had portal attendance access.';

  const copyText = async (label, value) => {
    if (!value) return;
    try {
      await navigator.clipboard.writeText(value);
      setCopied(label);
      setTimeout(() => setCopied(''), 2000);
    } catch {
      setCopied('');
    }
  };

  return createPortal(
    <div className="ea-dash-modal-backdrop" onClick={onClose} role="presentation">
      <div
        className="ea-dash-modal ea-hr-form-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="ea-hr-portal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button type="button" className="ea-dash-modal__close" onClick={onClose} aria-label="Close">
          ×
        </button>
        <h3 id="ea-hr-portal-title" className="ea-dash-modal__title">
          Portal access
        </h3>
        <p className="ea-dash-modal__subtitle">
          {employee.name || 'Employee'} · {statusNote}
        </p>

        {result.message && <p className="ea-hr-form-modal__hint">{result.message}</p>}

        <div className="ea-hr-portal-creds">
          <div className="ea-hr-portal-creds__row">
            <span className="ea-field-label">Login</span>
            <div className="ea-hr-portal-creds__value">
              <code>{portal.login || '—'}</code>
              {portal.login && (
                <button
                  type="button"
                  className="ea-hr-btn ea-hr-btn--ghost"
                  onClick={() => copyText('login', portal.login)}
                >
                  {copied === 'login' ? 'Copied' : 'Copy'}
                </button>
              )}
            </div>
          </div>
          {portal.password != null && portal.password !== '' && (
            <div className="ea-hr-portal-creds__row ea-hr-portal-creds__row--warn">
              <span className="ea-field-label">Password (show once)</span>
              <div className="ea-hr-portal-creds__value">
                <code>{portal.password}</code>
                <button
                  type="button"
                  className="ea-hr-btn ea-hr-btn--ghost"
                  onClick={() => copyText('password', portal.password)}
                >
                  {copied === 'password' ? 'Copied' : 'Copy'}
                </button>
              </div>
            </div>
          )}
          <p className="ea-hr-form-modal__meta">
            HR dashboard access:{' '}
            {portal.has_hr_dashboard_access ? 'Yes' : 'No'}
          </p>
        </div>

        <button type="button" className="ea-btn-submit ea-dash-modal__done" onClick={onClose}>
          Done
        </button>
      </div>
    </div>,
    document.body
  );
}
